import { useTranslation } from 'react-i18next';

import { WHEEL_PRIZES } from '@/entities/wheel/model/wheel.types';

import { formatNumber } from '@/shared/helpers/format-number';

import { type PrizeNameProps } from './types';

import s from './index.module.scss';

export const CoinPrizeName = ({ prize }: PrizeNameProps) => {
  const { t } = useTranslation();

  const getPrizeUnit = (prizeType: (typeof prize)['type']) => {
    switch (prizeType) {
      case WHEEL_PRIZES.PLAYCOIN:
        return '$PlayCoin';
      case WHEEL_PRIZES.NOT:
        return 'NOT';
      case WHEEL_PRIZES.TON:
        return 'TON';
      default:
        return prize.name;
    }
  };

  return (
    <div className={s.name}>
      {formatNumber(prize.amount, t)} {getPrizeUnit(prize.type)}
    </div>
  );
};
